<template>
  <div  class="halfbg">
    <headerNav title="半价活动" />

    <img style="width: 100%" src="../../../assets/images/cj03.jpg" />
    <div style="color: #fff;padding-bottom:15px">
      <van-divider :style="{ color: '#fff', borderColor: '#ffffff', padding: '0 16px','margin-top':'-115vw' }">
        <h2>我的半价权益卡</h2>
      </van-divider>
      <div class="drawcards">
        <div class="drawcard" v-for="item in list" :key="item.id" @click="nav(item)">
          <div class="draw-content">
            <div class="drawcard-pic">
              <img src="../../../assets/images/lipinquan.png" />
            </div>
            <div class="drawcard-wz">
              <div v-if="item.isUse" style="color: yellow">已使用 <span>| 使用时间:{{item.useTime}}</span></div>
              <div v-else>未使用 <span>| 领取时间:{{item.creationTime}}</span></div>
              <div v-if="item.tid">关联单号:{{item.tid}}</div>
              <div v-if="item.intervaStr">需等待{{item.intervaStr}}才可使用</div>
            </div>
          </div>
        </div>
        <div v-if="list.length == 0" style="text-align: center; font-size: 14px">
          您目前没有券哦,赶紧参与活动领取吧
        </div>
      </div>
    </div>
    <!-- <div>
       <img style="width: 100%" src="../../../assets/images/halfactive2.jpg" />
    </div> -->
  </div>
</template>
<script>
export default {
  data() {
    return {
      list: [],
    };
  },
  created() {
    this.ajax
      .post("/api/services/app/PhoneUser/QueryModelListRecord", {
        maxResultCount: 20,
        skipCount: 0,
      })
      .then((x) => {
        this.list=x.result.items;
        this.list.forEach(p=>{
              if(p.creationTime){
                  p.creationTime=p.creationTime.substr(0,10);
              }
              if(p.useTime){
                  p.useTime=p.useTime.substr(0,10);
              }
        });
      });
  },
  methods: {
    nav(item){
      if(!item.isUse){
          this.$router.push({path:'/retailcoupon'})
      }
    
    }
  },
};
</script>
<style lang="scss" scoped>
.drawcards {
  margin: 10px 20px;
  font-size: 14px;
}
.halfbg{
  //background:url(../../../assets/images/cj03.jpg) no-repeat;
  background-size: 100% 100%;
}
.drawcard {
  padding: 10px;
  background-color: #0000004d;
  border-radius: 4px;
}
.draw-content {
  position: relative;
  padding-left: 80px;
  min-height: 60px;
  line-height: 30px;
}
.drawcard-pic {
  position: absolute;
  left: 0;
  width: 60px;
  height: 60px;
  border-radius: 8px;
}
.drawcard-pic img {
  width: 100%;
  height: 100%;
}
</style>
